import { differenceInCalendarDays } from 'date-fns'

import { Granularity } from '@avantstay/arriere-clients/dist/arriereBackoffice'
import { getDatesFromPeriod, getPeriodFromDates } from '@avantstay/backoffice-core'

import { ControlOptionsProps } from '@new/__ui/ButtonGroup/_types'

export const addCheckedField = (
  option: ControlOptionsProps,
  period: { fromDate: string; toDate: string },
): ControlOptionsProps => {
  const optionPeriodString = getPeriodFromDates(getDatesFromPeriod(option.value))
  const periodString = getPeriodFromDates(period)

  if (optionPeriodString === periodString) {
    return { ...option, checked: true }
  }

  return option
}

export const isCustomOptionActive = (regularOptions: ControlOptionsProps[]) => {
  return regularOptions.every(it => !it.checked)
}

export const getGranularityOptions = (
  period: {
    fromDate: string
    toDate: string
  },
  granularity: string,
) => {
  const differenceInDays = differenceInCalendarDays(new Date(), new Date(period.fromDate))

  return [
    {
      title: 'D',
      value: Granularity.daily,
      id: Granularity.daily,
      checked: granularity === Granularity.daily,
    },
    {
      title: 'W',
      value: Granularity.weekly,
      id: Granularity.weekly,
      disabled: differenceInDays <= 8,
      checked: granularity === Granularity.weekly,
    },
    {
      title: 'M',
      value: Granularity.monthly,
      id: Granularity.monthly,
      disabled: differenceInDays <= 31,
      checked: granularity === Granularity.monthly,
    },
    {
      title: 'Q',
      value: Granularity.quarterly,
      id: Granularity.quarterly,
      disabled: differenceInDays <= 91,
      checked: granularity === Granularity.quarterly,
    },
  ]
}

export enum ChartsComparison {
  period = 'period',
  yearOverYear = 'yearOverYear',
}

export const getChartsComparisonOptions = (comparison?: ChartsComparison) => [
  {
    title: 'Previous period',
    value: ChartsComparison.period,
    id: ChartsComparison.period,
    checked: comparison === ChartsComparison.period,
  },
  {
    title: 'Year over year',
    value: ChartsComparison.yearOverYear,
    id: ChartsComparison.yearOverYear,
    checked: comparison === ChartsComparison.yearOverYear,
  },
]
